import React from 'react';
import {
  reduxForm,
} from 'redux-form';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { Show } from 'Layout';
import { PageStatus } from 'enums';
import { NewsLetterAPI } from "../../API";
import csvtojson from "csvtojson";

export type FormValue = {
  name: string,
};

class Form extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      status: PageStatus.None,
      error: null,
      loginRewards: [],
    };
  }

  formValues() {
    return {
      loginRewards: this.state.loginRewards,
    };
  }

  onSubmit() {
    if (!this.props.id) {
      return this.create();
    }
  }

  create() {
    const valuesIn = this.formValues();
    if (valuesIn.loginRewards.length === 0) {
      alert('No data to submit. Please upload a valid file.');
      return Promise.resolve();
    }
    const apiRespo = NewsLetterAPI.bulkcouponcreate(valuesIn);
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting }))
      .then(() => apiRespo)
      .then((data) => {
        alert(
          'Coupons uploaded summary\n' +
          'Total coupons in sheet: ' + data?.totalReceived + '\n' +
          'Successful Uploads: ' + data?.insertedCount + '\n' +
          'Failed Uploads: ' + data?.skippedCount
        );
        this.props.onSubmit(data.id);
        return this.setState({ status: PageStatus.Submitted });
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  checkDuplicasyInUploadedFile = (data) => {
    let filledData = data.map((obj) => this.modifiedConvertedJson(obj)).filter(item => item !== undefined);

    let uniqueRefNo = Array.from(new Set(filledData.map(item => item.referenceNo)));
    let uniqueCoupon = Array.from(new Set(filledData.map(item => item.rewardCoupon)));

    if (uniqueCoupon.length !== filledData.length) {
      alert(filledData.length - uniqueCoupon.length + ' Duplicate entries of coupons found in uploaded file. Please remove duplicates and try again.');
      return true;
    }

    if (uniqueRefNo.length !== filledData.length) {
      alert(filledData.length - uniqueRefNo.length + ' Duplicate entries of reference number found in uploaded file. Please remove duplicates and try again.');
      return true;
    }
    return false;
  }


  handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const jsonData = await this.convertCsvToJson(file);
        if (this.checkDuplicasyInUploadedFile(jsonData)) { event.target.value = null; return; }
        const loginRewards = jsonData.map((obj) => this.modifiedConvertedJson(obj)).filter(item => item !== undefined);
        this.setState({ loginRewards });
      } catch (error) {
        console.error('Error converting CSV to JSON:', error);
      }
    }
    else { alert('No file selected'); }
  };

  convertCsvToJson = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const csvContent: any = reader.result;
        if (!csvContent.trim()) {
          reject(new Error('CSV content is empty.'));
          return;
        }
        csvtojson().fromString(csvContent).then(jsonData => resolve(jsonData))
      };
      reader.onerror = (event) => {
        const message = reader.error?.message ?? 'Unknown error during file reading';
        reject(new Error(message));
      };
      reader.readAsText(file);
    });
  };


  modifiedConvertedJson = (obj) => {
    if (obj.name && obj.coupon && obj.expiry && obj.referenceNo) {
      return { rewardCorporation: obj.name.trim(), rewardCoupon: obj.coupon.trim(), expiryAt: obj.expiry.trim(), referenceNo: obj.referenceNo.trim() }
    }
  };

  render() {
    return (
      <Modal
        centered
        size="xl"
        backdrop="static"
        onHide={this.props.onClose}
        show={this.props.show}
        style={{ zIndex: 1201 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Add Partnership Coupons
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Alert variant="danger" show={this.state.status === PageStatus.Error}>
            {this.state.error}
          </Alert>

          <form onSubmit={this.props.handleSubmit(
            (event) => this.onSubmit(),
          )}
          >
            <div className="row ">
              <div className="col-12">
                <label htmlFor="bulkEmail" className="mt-2 ">Choose login reward coupons file</label>
                <input
                  type="file"
                  accept=".csv"
                  className="form-control "
                  id="bulkuserIds"
                  name="bulkuserIds"
                  onChange={(event) => this.handleFileChange(event)}
                />
              </div>
            </div>


            <Alert variant="danger" show={!!this.state.error} className="mt-2">
              {this.state.error}
            </Alert>

            <div className="d-flex align-items-center mt-2">
              <button
                type="submit"
                className="btn btn-primary mr-3"
              >
                Submit
              </button>

              <Show when={this.state.status === PageStatus.Submitting}>
                <Spinner animation="border" variant="primary" />
              </Show>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const dataFormRedux = reduxForm<any, any>({
  form: 'dataForm',
})(Form);

const dataFormWithRouter = withRouter(dataFormRedux);

export { dataFormWithRouter as Form };
